/**
 * https://stackoverflow.com/questions/10420352
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000.
 *           False to use binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const humanFileSize = (bytes:number, si=true, dp=0) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) return bytes + ' B';

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10**dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + ' ' + units[u];
};

export const isFullscreenAvailable = () => {
  return document.body.requestFullscreen ||
    // @ts-ignore - Safari
    document.body.webkitRequestFullscreen ||
    // @ts-ignore - IE11
    document.body.msRequestFullscreen;
};

export const requestFullscreen = (el:HTMLElement) => {
  if (el.requestFullscreen) {
    return el.requestFullscreen();
    // @ts-ignore
  } else if (el.webkitRequestFullscreen) {
    // @ts-ignore - Safari
    return el.webkitRequestFullscreen();
    // @ts-ignore
  } else if (el.msRequestFullscreen) {
    // @ts-ignore - IE11
    return el.msRequestFullscreen();
  }
};

export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
    // @ts-ignore
  } else if (document.webkitExitFullscreen) {
    // @ts-ignore - Safari
    return document.webkitExitFullscreen();
    // @ts-ignore
  } else if (document.msExitFullscreen) {
    // @ts-ignore - IE11
    return document.msExitFullscreen();
  }
};

export function mapRange(value: number, fromMin: number, fromMax: number, toMin: number, toMax: number) {
  if (value <= fromMin) return toMin;
  if (value >= fromMax) return toMax;

  value -= fromMin;
  fromMax -= fromMin;

  return (value / fromMax) * (toMax - toMin) + toMin;
};

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
};
